export default "__VITE_ASSET__BbXD38BE__"